class ApiClient {

    /**
     * This class makes api calls to Laravel backend
     */
    constructor() {

        this.baseUrl = window.MIX_APP_URL + '/api/';

        // default axios settings
        this.axios = window.axios.create({
            baseURL: this.baseUrl,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            },
        });

        // register global error handler
        this.axios.interceptors.response.use(
            (response) => { return Promise.resolve(response); }, 
            this._handleError)
    }

    /**
     * Global error handler 
     * Checks if feedback component exists and reports error if so
     * 
     * @param {Object} error 
     * @returns {Promise}
     */

    _handleError(error) {

        if(window.Feedback && window.Feedback.ErrorResponse)
        {
            window.Feedback.ErrorResponse(error);
            return Promise.reject(error);
        };
            
    }

    /**
     * Gets all product types
     * 
     * @returns {Promise}
     */
    productTypes() {
        return this.axios.get(`${this.baseUrl}product-type`);
    }

    /**
     * Gets countires that belong to productType with productTypeId
     * 
     * @param {Number} productTypeId
     * @param {Boolean} hasData whether to get all countires or just the ones that have any data 
     * @returns {Promise}
     */
    productTypeCountries(productTypeId, hasData = false) {
        return this.axios.get(`${this.baseUrl}product-type/${productTypeId}/country`, { params: {hasData : hasData} });
    }

    /**
     * Gets aois that belong to productType with productTypeId within a country
     * 
     * @param {Number} productTypeId
     * @param {Number} countryId
     * @param {Boolean} hasData whether to get all AOIs or just the ones that have any data
     * @returns {Promise}
     */
    productTypeCountryAois(productTypeId, countryId, hasData = false) {
        return this.axios.get(`${this.baseUrl}product-type/${productTypeId}/country/${countryId}/aoi`, { params: {hasData : hasData} });
    }

    /**
     * Gets all products for productType and its AOIs
     * 
     * @param {Number} productTypeId 
     * @param {Number} aoiId 
     * @returns {Promise}
     */
    productTypeAoiProducts(productTypeId, aoiId) {
        return this.axios.get(`${this.baseUrl}product-type/${productTypeId}/aoi/${aoiId}/product`);
    }

    /**
     * Gets operation result (view, change, summarize) for producttype, aoi and dates
     * 
     * @param {Number} productTypeId 
     * @param {Number} aoiId 
     * @param {Number} operation 
     * @param {String} from ISO date
     * @param {String} to ISO date - defaults to null - ignored if view operation
     * @returns {Promise}
     */
    operation(productTypeId, aoiId, operation, from, to = null) {

        let url =  `${this.baseUrl}product-type/${productTypeId}/aoi/${aoiId}/${operation}`;

        let params = {}

        if(operation == 'view')
            params['date'] = from;

        else {
            params['from'] = from;
            params['to'] = to;
        }

        return this.axios.get(url, { params : params });
    }

}


export default ApiClient;
